import React, { useMemo, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'
import cls from '../EventForm.module.scss'

import UikFormInputGroup from 'components/UikFormInputGroup'
import UikSelect from 'components/UikSelect'

import { constants } from 'helpers'
import { SET_TAG } from '../constants'
import CardHeader from '../components/CardHeader'
import FieldTitle from '../components/FieldTitle'
import { miscellaneousToOption } from '../utils'

const {
  EVENT_CONSTANTS: { VISIBILITY },
} = constants
const eventVisibilityOptions = Object.values(VISIBILITY).map(option => ({
  value: option,
  label: option,
}))
const nonAdminHostVisibilityOption = [{ value: VISIBILITY.PRIVATE, label: VISIBILITY.PRIVATE }]

// TODO: check commented code once we add sub categories back.
const CategoryAndVisibilityStep = ({
  admin,
  formState,
  setFormState,
  categories,
  subCategoriesByCategory,
}) => {
  const categoriesOptions = useMemo(
    () => categories.map(category => miscellaneousToOption(category)),
    [categories]
  )
  const [categoryOption, setCategoryOption] = useState(categoriesOptions.slice(0, 1))
  const visibilityOptions = useMemo(
    () => (admin ? eventVisibilityOptions : nonAdminHostVisibilityOption),
    [admin]
  )

  useEffect(() => {
    if (!isEmpty(categoryOption)) {
      const subCategories = subCategoriesByCategory[categoryOption[0].value]
      setFormState({
        type: SET_TAG,
        tag: { category: [subCategories[0].id] },
      })
    }
  }, [categoryOption, setFormState, subCategoriesByCategory])

  const eventVisibilitySelected = {
    value: formState.eventVisibility,
    label: formState.eventVisibility,
  }

  return (
    <div className={cls.cardContainer}>
      <CardHeader
        stepNumber="3"
        title="Event Category"
        info="Choose the category that applies to your event so that people can find you more easily"
      />
      <div className={cls.card}>
        <div className={cls.fieldContainer}>
          <FieldTitle title="Event Visibility" />
          <div className={cls.selectWrappper}>
            <UikFormInputGroup horizontal>
              <UikSelect
                placeholder={formState.eventVisibility}
                className={cls.selectItem}
                options={visibilityOptions}
                position="bottomRight"
                name="eventVisibility"
                value={[eventVisibilitySelected]}
                defaultValue={[eventVisibilitySelected]}
                onChange={selected => setFormState({ eventVisibility: selected.value })}
                disabled={!admin}
              />
            </UikFormInputGroup>
          </div>
        </div>
        <div className={cls.fieldContainer}>
          <FieldTitle title="Category" />
          <div className={cls.selectWrappper}>
            <UikFormInputGroup horizontal>
              <UikSelect
                placeholder="Select Category"
                className={cls.selectItem}
                options={categoriesOptions}
                value={categoryOption}
                defaultValue={categoryOption}
                onChange={selected => setCategoryOption([selected])}
                position="bottomRight"
                name="eventCategory"
              />
            </UikFormInputGroup>
          </div>
        </div>
      </div>
    </div>
  )
}

CategoryAndVisibilityStep.propTypes = {
  categories: PropTypes.array.isRequired,
  subCategoriesByCategory: PropTypes.object.isRequired,
}

export default CategoryAndVisibilityStep
